export default __webpack_public_path__ + "static/media/img (3).4a97f5c6.jpg";